import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
const sizeMap = {
    sm: 'w-8 h-8 border-4',
    lg: 'w-12 h-12 border-8',
};
const colorMap = {
    green: 'border-green',
    gold: 'border-gold',
    white: 'border-white',
    black: 'border-black',
};
const Spinner = ({ size = 'sm', color = 'green', }) => {
    const classes = classNames('animate-spin rounded-full border-r-transparent', sizeMap[size], colorMap[color]);
    return _jsx("div", { className: classes });
};
export default Spinner;
